export default "__VITE_ASSET__6b1f68af__"